import React from 'react';
import { analyticsConfigured } from '../../config/posthog';
import { openConsentSettings } from '../../config/consent';

/**
 * "Cookie settings": reopens the consent banner so the visitor can change or
 * withdraw their analytics choice. Nothing to show in a build without analytics.
 */
const CookieSettingsLink: React.FC<{ className?: string }> = ({ className }) => {
  if (!analyticsConfigured()) return null;
  return (
    <button type="button" onClick={openConsentSettings} className={className}>
      Cookie settings
    </button>
  );
};

export default CookieSettingsLink;
